/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'oci',

  can: {
    // page access guarded by auth-routes.  these rules set up the perimeter for page level access rights

    view() {
      return true;
    },

    viewAllCampaigns() {
      return this.isSuper() || this.isOciFinanceDirector() || this.isPartnerFounder() || this.isOciCampaignAuthor()
    },

    viewConditionsAdmin() {
      return this.isSuper() || this.isOciBroker();
    },


    sendMarketingCampaign() {
      return this.isSuper();
    },
    viewBrokerChat() {
      return this.isSuper() // || this.isOciBroker(); for now disabled to broker use
    },
    isBroker() {
      return this.isOciBroker()
    },
    useBrokerChat() {
      return this.isOciBroker()
    },
    viewBrokerLinks() {
      return this.isSuper() || this.isOciBroker();
    },
    viewMortgageApp() {
      return this.isSuper() || this.isOciBroker();
    },
    useMortgageApp() {
      return this.isSuper() || this.isOciBroker()
    },
    sendCreditRequestPROD() {
      return (this.isOciCreditRequester() || this.isOciBrokerManager()) && process.env.NODE_ENV === 'production'
    },
    sendCreditRequestUAT() {
      return this.isSuper() || ((this.isOciCreditRequester() || this.isOciBrokerManager()) && process.env.NODE_ENV !== 'production')

    },
    requestCreditBureau() {
      return this.isSuper() || this.isOciCreditRequester() || this.isOciBrokerManager()
    },
    sendCreditorInsuranceRequestUAT() {
      return this.isSuper() || ((this.isOciCreditRequester() || this.isOciBrokerManager()) && process.env.NODE_ENV !== 'production')
    },
    sendCreditorInsuranceRequestPROD() {
      return (this.isOciCreditRequester() || this.isOciBrokerManager()) && process.env.NODE_ENV === 'production'
    },
    submitToLender() {
      return this.isOciBrokerManager() || this.isOciLenderTransmitter()
    },
// Dashboard Menu Items
    viewAdminDashboard() {
      return this.isSuper()
    },

    // Dashboard Menu Items
    viewOciDashboard() {
      return this.isSuper() || this.isOciBroker() || this.isOciCampaignAuthor() || this.isOciSales();
    },
    viewOciOperationsDashboard() {
      return this.isSuper() || this.isOciFinanceDirector() || this.isOciPresident()
    },
    viewPartnerDashboard() {
      return this.isSuper() || this.isPartner() || this.isOciBrokerManager()
    },
    canViewSalesMenu() {
      return this.isOciSales || this.isSuper() || this.isOciBroker();
    },

    viewLenderSubmissionCheckBox() {
      return this.isOciBroker();
    },
    //client management exporting feature
    canExportClientData() {
      return this.isOciClientExporter() || this.isSuper();
    }
  },
  isSuper() {
    return this.child.isSuper;
  },
  isOci() {
    return this.child.isOci;
  },

  isPartner() {
    return this.child.isPartner;
  },
  isPartnerFounder() {
    return this.child.isPartnerFounder;
  },
  isPartnerInvestor() {
    return this.child.isPartnerInvestor;
  },
  isOciBroker() {
    return this.child.isOciBroker;
  },
  isOciBrokerManager() {
    return this.child.isOciBrokerManager;
  },
  isOciManager() {
    return this.child.isOciManager;
  },
  isOciDeveloper() {
    return this.child.isOciDeveloper;
  },
  isOciLenderTransmitter() {
    return this.child.isOciLenderTransmitter;
  },
  isOciCreditRequester() {
    return this.child.isOciCreditRequester;
  },
  isOciGroup() {
    return this.child.isOciGroup;
  },
  isLenderGroup() {
    return this.child.isLenderGroup;
  },
  isSuperGroup() {
    return this.child.isSuperGroup;
  },
  isDeveloperGroup() {
    return this.child.isDeveloperGroup;
  },
  isPartnerGroup() {
    return this.child.isPartnerGroup;
  },
  isOciFinanceDirector() {
    return this.child.isOciFinanceDirector;
  },
  isOciFinance() {
    return this.child.isOciFinance;
  },
  isOciPresident() {
    return this.child.isOciPresident;
  },
  isOciCampaignAuthor() {
    return this.child.isOciCampaignAuthor;
  },
  isOciSales() {
    return this.child.isOciSales;
  },
  isOciClientExporter(){
    return this.child.isOciClientExporter;
  }





});
